import React, { useState } from 'react';
// @ts-ignore
import styles from './RootBillingAddress.module.scss';
import {
	AddressType,
	useLazyWorkplaceBillingAddressQuery,
	useRootWorkplaceByChildQuery,
} from '../../../../../graphql/graphql';
import { useAppContext } from '../../../../../Services/AppContext';
import Loading from '../../../../Loading';
import { useEffectAsync } from '../../../../../helpers';
import useBillingAddressContainer from '../../../Hooks/useBillingAddressContainer';
import Text from '../../../../Base/Text/Text';
import FirstUpper from '../../../../FirstUpper';
import { ItemScheme } from '../../../../Form/MagicFormItem';

const RootBillingAddress: React.FC = () => {
	const { workplaceId } = useAppContext();
	const [isLoading, setIsLoading] = useState(false);
	const { data, isLoading: rootWorkplaceIsLoading } =
		useRootWorkplaceByChildQuery({ workplaceId });
	const rootWorkplaceId = data?.workplace?.rootWorkplace?.id;
	const [getBillingAddress] = useLazyWorkplaceBillingAddressQuery();
	const { billingAddressContainerScheme } = useBillingAddressContainer();
	const [billingAddress, setBillingAddress] = useState<
		{ label: string; value: string }[]
	>([]);

	const buildBillingAddressFromScheme = (
		scheme: ItemScheme[],
		data: Record<string, string>,
		output: { label: string; value: string }[],
	) => {
		scheme?.forEach(item => {
			let value: string | undefined = undefined;
			if (item.key && data?.[item.key]) {
				value = data?.[item.key];
			}
			if (item?.type === 'select') {
				const title = item.children?.find(
					child => (child.value = value),
				)?.title;
				if (title) {
					value = title;
				}
			}
			if (item?.type === 'hstack') {
				buildBillingAddressFromScheme(
					item.children as ItemScheme[],
					data,
					output,
				);
			}

			if (item.title && item.key && value) {
				output.push({
					label: item.title,
					value: value,
				});
			}
		});
	};

	useEffectAsync(async () => {
		if (rootWorkplaceId) {
			setIsLoading(true);
			const rootBillingAddress = await getBillingAddress({
				where: {
					workplaceId: rootWorkplaceId,
					type: AddressType.Billing,
				},
			});
			const data: Record<string, string> = rootBillingAddress?.data
				?.workplaceAddress as Record<string, string>;
			const scheme = await billingAddressContainerScheme();
			const tempBillingAddress: { label: string; value: string }[] = [];
			buildBillingAddressFromScheme(
				scheme[0].children as ItemScheme[],
				data,
				tempBillingAddress,
			);
			setBillingAddress(tempBillingAddress);
			setIsLoading(false);
		}
	}, [rootWorkplaceId]);

	if (isLoading || rootWorkplaceIsLoading) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.addressContainer}>
				<Text
					className={styles.title}
					tx='component.rootBillingAddress.invoicingAddressOfRoot'
				/>
				{billingAddress?.map((item, key) => (
					<div key={key}>
						<FirstUpper>{item.label}</FirstUpper>: <span>{item.value}</span>
					</div>
				))}
			</div>
		</div>
	);
};

export default RootBillingAddress;
